// extracted by mini-css-extract-plugin
export default {"dataProtection":"DataProtectionPage_dataProtection__kVyVf"};